export class LogPrettier {
  private name: string;
  protected dateStyle = "color:#bdc4ca;";
  protected levelStyle = "font-weight:bold;color:gray;";
  protected infoStyle = "font-weight:bold;color:#7f8d90;";
  protected logStyle = "font-weight:bold;color:#ebeff2;";
  protected warnStyle = "font-weight:bold;color:#f2c311;";
  protected errorStyle = "font-weight:bold;color:#e84c3d;";
  protected debugStyle = "font-weight:bold;color:#8d45ab;";
  protected nameStyle = "color:#ebeff2;background-color:#4b5b6b;";

  constructor({ name }: { name: string }) {
    this.name = name;
  }

  protected base(
    level: "info" | "log" | "warn" | "error" | "debug",
    ...args: any[]
  ): any[] {
    return [
      `%c [${
        new Date().toLocaleString()
      }] %c${level.toUpperCase()} %c ${this.name} `,
      this.dateStyle,
      this[`${level}Style`],
      this.nameStyle,
      ...args,
    ];
  }
  public info(...args: any[]): any[] {
    return this.base("info", ...args);
  }

  public log(...args: any[]): any[] {
    return this.base("log", ...args);
  }

  public warn(...args: any[]): any[] {
    return this.base("warn", ...args);
  }

  public error(...args: any[]): any[] {
    return this.base("error", ...args);
  }

  public debug(...args: any[]): any[] {
    return this.base("debug", ...args);
  }
}
export const LogAppInfo = new LogPrettier({ name: "AppInfo" });

export const LogInit = new LogPrettier({ name: "InitLogic" });

export const LogStore = new LogPrettier({ name: "StoreLogic" });

export const LogBusinessRequest = new LogPrettier({
  name: "BusinessRequest",
});
